import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Api} from '../utils';
import {RequestsHandler} from './requests.service';
import {Observable} from 'rxjs/Observable';
import {Statistics} from '@models/statistics.interface';
import {CookieService} from 'ngx-cookie';
import {ORDER_DOCUMENTS_LOAD} from '@store/actions';
import {UUID} from 'angular2-uuid';
import {Document, DocumentType} from '@store/reducers/order-completion.reducer';
import {Store} from '@ngrx/store';
import {selectOrderCompletion} from '@store/reducers';
import 'rxjs/add/operator/map';

interface RequestOptions {
  headers: HttpHeaders;
  responseType: string;
}
@Injectable()
export class AccountService {
  orderCompletion: any;
  constructor(
    private http: HttpClient,
    private api: Api,
    private handler: RequestsHandler,
    private _cookieService: CookieService,
    private store: Store<any>
  ) {
    this.store.select(selectOrderCompletion)
      .subscribe(data => this.orderCompletion = data);
  }

  getBillingAddress() {
    return this.http.get(this.api.getUrl('account/billingAddress'), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  setBillingAddress(address) {
    return this.http.post(
      this.api.getUrl('account/billingAddress'), JSON.stringify(address),{headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  importAddressFile(encoded_file: string, type: string, format: string, updateRecords: boolean): Observable<any> {
    return this.http.post(
      this.api.getUrl('imports/address', 'v2'), {
        type: type,
        format: format,
        encoded_content: encoded_file,
        update_records: updateRecords
      },
      {headers: this.handler.headers()}
    );
  }

  importShipmentFile(encoded_file: string, type: string): Observable<any> {
    return this.http.post(
      this.api.getUrl('account/saved-searches/import'), {
        "content_type": type,
        "encoded_content": encoded_file
      },
      {headers: this.handler.headers()}
    );
  }

  getStatistics(): Observable<Statistics> {
    return this.http.get(this.api.getUrl('account/statistics'), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getShipmentHistories() {
    return this.http.get(this.api.getUrl('account/shipments/history'), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getShipmentConsignmentByKey(key: string | number): Observable<any> {
    return this.http.get(this.api.getUrl(`account/shipments/consignment/${key}`), {headers: this.handler.headers()});
  }

  saveOrder(order) {
    return this.http.post(
      this.api.getUrl('account/orders'), JSON.stringify(order), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getOrderById(id ) {
    return this.http.get(
      this.api.getUrl(`account/orders/${id}`),
      {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  setCreditCard(data) {
    return this.http.post(
      this.api.getUrl('account/cards'), JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  setDefaultCreditCard(id) {
    return this.http.patch(
      this.api.getUrl(`account/cards/${id}`), {}, {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      })
  }

  /*
  getOrderDocuments(orderId) {
    return this.http.get(
      this.api.getUrl(`account/orders/${orderId}/documents`),
      {headers: this.handler.headers()}
    ).catch((err: any) => {
      this.handler.handleError(err);
      return Observable.throw(new Error(err));
    })
  }

  getLabelBlob(url): any {

    const options: any = {
      headers: this.handler.headers(),
      responseType: 'blob'
    };
    return this.http.get(url, options)
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getOrderFiles() {

  }

  getShipmentDocuments() {
    if (!this.orderCompletion.data.order.database_id) {
      return;
    }
    const { labels, receipts } = this.orderCompletion.documents;
    if (!labels || !labels.length || !receipts || !receipts.length) {
      return this.http.get(
        this.api.getUrl(`account/orders/${this.orderCompletion.data.order.database_id}/documents`),
        {headers: this.handler.headers()}
      ).do((data: Document[]) => {
          this.store.dispatch({
            type: ORDER_DOCUMENTS_LOAD,
            payload: {
              documents: {
                labels: data.filter(({type}) => type === DocumentType.Label)
                  .map(label => ({...label, id: UUID.UUID()})) || [],
                receipts: data.filter(({type}) => type === DocumentType.Receipt)
                  .map(label => ({...label, id: UUID.UUID()})) || [],
              }
            }
          })})
        .catch((err: any) => {
          return Observable.throw(new Error(err));
        });
    } else {
      return Observable.of(true);
    }
  }
  */

  saveSearchDraft(data) {
    return this.http.post(
      this.api.getUrl('account/saved-searches'), JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  updateSearchDraft(data, id) {
    return this.http.put(
      this.api.getUrl(`account/saved-searches/${id}`), JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getShipments(params) {
    let options = {
      headers: this.handler.headers(),
      params: new HttpParams()
    };
    Object.entries(params).forEach(([key, value]) => {
      if (key === 'statuses') {
        value.forEach(status => options.params = options.params.append('status[]', status))
      } else {
        options.params = options.params.append(key, value);
      }
    });
    return this.http.get(this.api.getUrl('account/shipments'), options)
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getShipment(id) {
    return this.http.get(
      this.api.getUrl(`account/shipments/${id}`),
      {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getShipmentDocumentsById(id) {
    return this.http.get(
      this.api.getUrl(`account/shipments/${id}/documents`),
      {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  getSearchDraft(params) {
    const options: any = {
      headers: this.handler.headers(),
      params: new HttpParams().set('is_used', '0'),
    };
    Object.keys(params).forEach(key => {
      options.params = options.params.set(key, params[key]);
    });
    return this.http.get(
      this.api.getUrl('account/saved-searches'), options)
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  removeSearchDraft(id) {
    return this.http.delete(
      this.api.getUrl(`account/saved-searches/${id}`), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/account.service.ts